import { Link } from "react-router-dom";
import successIcon from "../../assets/icons/success.svg"; // You'll need to add this icon

function Success() {
	return (
		<div className='min-h-[80vh] flex items-center justify-center bg-[#F6FEFA]'>
			<div className='text-center p-8 max-w-2xl mx-auto'>
				<div className='mb-6'>
					<img
						src={successIcon}
						alt='Success'
						className='w-20 h-20 mx-auto mb-4'
					/>
				</div>
				<h1 className='text-3xl font-bold text-[#11112D] mb-4'>
					Thank You for Your Donation!
				</h1>
				<p className='text-[#43474F] mb-8 text-lg'>
					Your generous contribution will help us continue our mission of
					providing healthcare access to those in need. We've sent a
					confirmation email with the details of your donation.
				</p>
				<div className='flex flex-col sm:flex-row gap-4 justify-center'>
					<Link
						to='/'
						className='px-6 py-3 bg-[#0F713E] text-white rounded-full hover:bg-[#0a5a32] transition-colors'>
						Return Home
					</Link>
					<Link
						to='/impact'
						className='px-6 py-3 border-2 border-[#0F713E] text-[#0F713E] rounded-full hover:bg-[#0F713E] hover:text-white transition-colors'>
						See Your Impact
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Success;
